export default __webpack_public_path__ + "static/media/portfolio-185.1d23a310.jpg";